import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { selectLoggedInUser } from "../authSlice";
import useIdleTimer from "../../AutoLogout/useIdleTimer";

function Protected({ children }) {
  const user = useSelector(selectLoggedInUser);

  useIdleTimer();

  if (!user) {
    return <Navigate to="/Login" replace={true} />;
  }

  return children;
}

export default Protected;
